/**
 * Created Date: 2019-03-22
 * Author: Grays
 * -----
 * Last Modified: 2020-10-20 10:21:26
 * Modified By: Grays
 * 
 */


import Vue from 'vue'
import { request } from "@/utils/request";

export const exists_user = (user) => {
  return new Promise<boolean>((resolve, reject) => {
      Vue.$axios({
          url: '/isso/api/user/exists',
          method: 'post',
          data: {       
            user:user
          }
      }).then((d) =>{
          if (d.data.code==0){
              resolve(d.data.data)
          }else{
            reject('无法校验用户名,请重试...')
          }
      }).catch((d)=>{
        console.log(d);
        reject(d);
      })
  })
}

export const exists_user_mobile = (mobile) => {
  return new Promise<boolean>((resolve, reject) => {
      Vue.$axios({
          url: '/isso/api/user/mobile/exists',
          method: 'post',
          data: {       
            mobile:mobile
          }
      }).then((d) =>{
          if (d.data.code==0){
              resolve(d.data.data)
          }else{
            reject('无法校验手机号码,请重试...')
          }
      }).catch((d)=>{
        console.log(d);
        reject(d);
      })
  })
}


/**
 *通用的数据post方法
 *
 * @param {*} url
 * @param {*} [data={}]
 * @returns
 */
export const api_post=(url, data={})=>{
  return new Promise<any>((resove,reject)=>{
      request.post(url,data).then((res) =>{
          resove(res.data)
      }).catch(res=>{
          console.error(res)
          reject(res.msg)
      })   
  })   
}

/**
 *通用的数据post方法
 *
 * @param {*} url
 * @param {*} [data={}]
 * @returns
 */
export const api_get=(url, data={})=>{
  return new Promise<any>((resove,reject)=>{
      request.get(url,data).then((res) =>{
          resove(res.data)
      }).catch(res=>{
          console.error(res)
          reject(res.msg)
      })
  })
}
